<div [formGroup]="form">
  <div class="editor-tag" (click)="focusTagInput()">
    <span class="tag-item" *ngFor="let tag of tags">
      <!-- <span class="remove-tag" (click)="removeTag(tag)">×</span> -->
      <i class="icon-clear remove-tag" (click)="removeTag(tag)"></i>
      <span>{{ tag }}</span>
    </span>
    <input
      [placeholder]="'ClientApp.Projects.FrameWorkShell.Shared.Controls.TagInput.NewTitle' | translate"
      #tagInput
      type="text"
      class="input-tag"
      (keyup)="onKeyUp($event)"
      [formControl]="form.get('tag')" />
  </div>
</div>
